import { Collapse, CollapseProps } from 'antd';
import { FC, ReactNode } from 'react';
import { Comment } from '../../../../../ types';
import CommentBlock from './CommentBlock';
import * as styles from './index.module.scss';

interface IProps {
  expandIcon: (panelProps: any) => ReactNode;
  comments?: Comment[];
}

const CommentsBlock: FC<IProps> = ({ expandIcon, comments }) => {
  const commentsCollapseItems: CollapseProps['items'] = [
    {
      key: '1',
      label: 'КОММЕНТАРИИ',
      // children: (
      //   <div className={styles.commentsWrap}>
      //     {comments
      //       ?.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
      //       ?.map((comment) => <CommentCard key={comment._id} {...comment} />)}
      //   </div>
      // ),
      children: (
        <div className={styles.commentsWrap}>
          {comments
            ?.toSorted((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
            ?.map((comment) => <CommentBlock key={comment._id} {...comment} />)}
        </div>
      ),
    },
  ];

  return (
    <Collapse
      items={commentsCollapseItems}
      expandIcon={expandIcon}
      expandIconPosition="right"
      bordered={false}
      defaultActiveKey={[1]}
      ghost
    />
  );
};

export default CommentsBlock;
